export default __webpack_public_path__ + "static/media/sell (3).ae1d2a70.png";